import { lazy } from "react";

export const PageViewIntroduce = lazy(() => import("./component/Container"));
